export default "__VITE_ASSET__CQUqAA3m__"